import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Thanetoshirdicab() {



    const cardData = {





keyword: "Thane to Shirdi Cab",
headingDescription: "Sai Shirdi Cab offers reliable Thane to Shirdi cab service for devotees, families, couples, senior citizens, business travelers, and small groups looking for a comfortable private journey to Shirdi. Passengers can book a suitable cab for one-way travel, round-trip service, return journeys, or customized pilgrimage plans according to their schedule. The service provides convenient pickup from Thane and direct transportation to Shirdi, helping travelers avoid the inconvenience of changing vehicles during the journey. Sai Shirdi Cab can also arrange customized outstation itineraries for passengers who want to include religious, heritage, or leisure destinations along with their Shirdi visit. With planned pickup and drop arrangements, experienced drivers, and flexible travel options, the Thane to Shirdi cab service is suitable for both short pilgrimage visits and extended Maharashtra tours.",

topPlaces: [
{
title: "Shani Shingnapur",
description: "Shani Shingnapur is an ideal destination to add to a Thane to Shirdi pilgrimage itinerary. Travelers can book a private cab with Sai Shirdi Cab to cover Shirdi and Shani Shingnapur in a coordinated journey. The route can be arranged as a one-way trip, round trip, or multi-stop pilgrimage plan, giving families and devotees flexibility to manage temple visits and return travel."
},
{
title: "Nashik",
description: "Nashik is a convenient destination to combine with a Shirdi journey for travelers interested in pilgrimage and sightseeing. Sai Shirdi Cab can arrange private transportation for passengers traveling from Thane who want to include Nashik before or after their Shirdi visit. A customized itinerary can accommodate sightseeing stops, temple visits, overnight stays, and return travel."
},
{
title: "Trimbakeshwar",
description: "Trimbakeshwar is a suitable addition to a religious tour covering Shirdi from Thane. Devotees and families can book a private cab through Sai Shirdi Cab and plan both destinations within one organized itinerary. Flexible cab arrangements make it easier to coordinate temple visits, departure times, intermediate stops, and the return journey."
},
{
title: "Bhimashankar",
description: "Bhimashankar is another important pilgrimage destination that can be included in an extended Shirdi travel plan from Thane. Sai Shirdi Cab can arrange private outstation transportation for families and devotees who want to cover multiple religious destinations in one trip. The journey can be customized for direct travel, round trips, or multi-day pilgrimage tours."
},
{
title: "Bhandardara",
description: "Bhandardara offers a peaceful nature-focused option for travelers extending their Shirdi trip into a Maharashtra sightseeing tour. Families, friends, and small groups can use Sai Shirdi Cab for private transportation with a flexible itinerary. The trip can include planned sightseeing stops, overnight travel, and return arrangements according to the group's schedule."
},
{
title: "Mahabaleshwar",
description: "Mahabaleshwar is a good choice for passengers planning a longer family vacation after visiting Shirdi. Sai Shirdi Cab can arrange a private cab for travelers who want to combine pilgrimage with leisure travel. One-way, round-trip, and multi-day cab options allow passengers to plan their route around sightseeing, accommodation, and preferred travel timings."
},
{
title: "Ajanta-Ellora Caves",
description: "Ajanta-Ellora Caves provide an excellent heritage sightseeing option for travelers combining Shirdi with Chhatrapati Sambhajinagar. Sai Shirdi Cab can organize private cab transportation for families, couples, and small groups who prefer a flexible sightseeing schedule. The itinerary can include Shirdi, historical attractions, additional stops, and return travel."
},
{
title: "Aurangabad",
description: "Aurangabad, officially known as Chhatrapati Sambhajinagar, can be included in an extended outstation journey from Thane through Shirdi. The destination is suitable for travelers interested in heritage, culture, and sightseeing. Sai Shirdi Cab can arrange private transportation with customized stops, making it easier to combine a Shirdi pilgrimage with a broader Maharashtra travel itinerary."
},
{
title: "Pune",
description: "Pune is a useful destination for travelers planning an extended Maharashtra trip that includes Shirdi. Business travelers, families, and small groups can book private cab transportation through Sai Shirdi Cab for flexible intercity travel. The itinerary can be arranged as a one-way transfer, round trip, or multi-destination journey based on the passenger's complete travel plan."
},
{
title: "Saputara",
description: "Saputara is a scenic leisure destination that can be considered for travelers extending their Shirdi pilgrimage into a multi-day holiday. Sai Shirdi Cab can provide private cab arrangements for families and small groups who want to combine religious travel with a relaxing hill-station visit. Customized routes can include sightseeing, planned breaks, overnight stays, and return transportation."
}
]
,









"services": [
{
"name": "Thane to Shirdi Cab",
"description": "Thane to Shirdi Cab provides convenient private transportation for devotees, families, and travelers visiting Shirdi from Thane. Customers can choose a suitable vehicle according to passenger count, luggage requirements, pickup location, travel schedule, and one-way or return journey needs."
},
{
"name": "Thane to Shirdi Taxi",
"description": "Thane to Shirdi Taxi offers comfortable point-to-point travel for passengers heading to Shirdi. The service is suitable for individual travelers, families, and groups looking for a private cab with convenient pickup arrangements and flexible travel plans."
},
{
"name": "Thane to Shirdi cab service",
"description": "Thane to Shirdi cab service provides a practical transportation option for devotees and tourists planning a private journey to Shirdi. Cabs can be arranged according to the preferred departure time, passenger requirements, luggage, and planned itinerary."
},
{
"name": "Thane to Shirdi taxi service",
"description": "Thane to Shirdi taxi service makes travel between Thane and Shirdi more convenient with private transportation options. Passengers can arrange suitable vehicles for pilgrimage trips, family travel, sightseeing, and customized journeys based on their schedule."
},
{
"name": "Thane to Shirdi cab booking",
"description": "Thane to Shirdi cab booking allows travelers to reserve their preferred vehicle before starting their pilgrimage or family journey. Customers can share the travel date, pickup point, destination, passenger count, luggage needs, and required car category."
},
{
"name": "Thane to Shirdi taxi booking",
"description": "Thane to Shirdi taxi booking helps passengers organize private transportation in advance for a planned Shirdi visit. It is suitable for families, devotees, senior travelers, and groups who want their cab arranged according to their preferred departure schedule."
},
{
"name": "Thane to Shirdi taxi fare",
"description": "Thane to Shirdi taxi fare may vary depending on the selected vehicle, journey type, travel schedule, and additional requirements. Travelers can select a suitable taxi arrangement based on their budget and whether they need one-way or round-trip transportation."
},
{
"name": "Thane to Shirdi cab fare",
"description": "Thane to Shirdi cab fare depends on factors such as vehicle category, route, trip duration, and booking requirements. Customers can discuss their complete travel plan and select a suitable cab for their pilgrimage, family trip, or private journey."
},
{
"name": "Thane to Shirdi one way cab",
"description": "Thane to Shirdi one way cab is convenient for travelers who require direct transportation to Shirdi without booking a return vehicle. It is suitable for devotees and passengers who plan to continue their journey from Shirdi to another destination."
},
{
"name": "Thane to Shirdi one way taxi",
"description": "Thane to Shirdi one way taxi provides direct private transportation for passengers traveling to Shirdi. The journey can be planned according to the preferred pickup point, departure time, passenger count, luggage, and destination requirements."
},
{
"name": "Thane to Shirdi round trip cab",
"description": "Thane to Shirdi round trip cab is suitable for travelers planning to visit Shirdi and return to Thane after completing their darshan or sightseeing. The journey can be organized around the temple visit, stay duration, preferred return time, and overall itinerary."
},
{
"name": "Thane to Shirdi Ertiga Cab",
"description": "Thane to Shirdi Ertiga Cab is a convenient option for families and small groups looking for a spacious private vehicle. It can be arranged for pilgrimage travel with comfortable seating and luggage space according to the group's travel requirements."
},
{
"name": "Thane to Shirdi Innova Cab",
"description": "Thane to Shirdi Innova Cab provides a spacious travel option for families and groups visiting Shirdi. The vehicle can be booked for one-way journeys, round trips, Sai Baba darshan, and customized travel plans based on passenger and luggage requirements."
},
{
"name": "Thane to Shirdi Innova Crysta Cab",
"description": "Thane to Shirdi Innova Crysta Cab is suitable for travelers seeking a premium and spacious vehicle for the journey. It works well for family pilgrimages, group travel, and longer trips where passengers prefer additional comfort and private transportation."
},
{
"name": "Thane to Shirdi Sedan Cab",
"description": "Thane to Shirdi Sedan Cab offers a comfortable transportation option for individuals, couples, and small families traveling to Shirdi. The sedan can be arranged for direct travel, pilgrimage visits, one-way bookings, and round-trip journeys."
},
{
"name": "Thane to Shirdi car rental",
"description": "Thane to Shirdi car rental provides a convenient private vehicle option for travelers planning a journey to Shirdi. Customers can select a suitable car based on passenger capacity, luggage requirements, route, travel duration, and whether the trip is one-way or round trip."
},
{
"name": "Thane to Shirdi outstation cab",
"description": "Thane to Shirdi outstation cab is designed for passengers planning a private long-distance journey from Thane to Shirdi. It can be arranged for devotees, families, tourists, and groups with suitable vehicle options and flexible travel schedules."
},
{
"name": "Thane to Shirdi Sai Baba Darshan Cab",
"description": "Thane to Shirdi Sai Baba Darshan Cab is suitable for devotees traveling from Thane to visit Sai Baba Temple in Shirdi. Private transportation can be planned around the preferred departure time, darshan schedule, passenger needs, and return journey requirements."
},
{
"name": "Shirdi to Thane Taxi",
"description": "Shirdi to Thane Taxi provides convenient return transportation for devotees and travelers completing their Shirdi visit. Customers can arrange a suitable vehicle according to passenger count, luggage, pickup location, departure schedule, and onward travel requirements."
},
{
"name": "Shirdi to Thane Cab",
"description": "Shirdi to Thane Cab offers private transportation for passengers traveling back to Thane after visiting Shirdi. The service is suitable for families, devotees, and groups who need a comfortable vehicle with flexible pickup and travel arrangements."
},
{
"name": "Sai Shirdi Cabs",
"description": "Sai Shirdi Cabs provides Thane to Shirdi cab and taxi services for devotees, families, tourists, and groups. Customers can book Sedan, Ertiga, Innova, or Innova Crysta options for one-way, round-trip, Sai Baba darshan, car rental, and customized outstation travel."
}
],
"tableData": [
["Thane to Shirdi Cab", "Thane to Shirdi Taxi"],
["Thane to Shirdi cab service", "Thane to Shirdi taxi service"],
["Thane to Shirdi cab booking", "Thane to Shirdi taxi booking"],
["Thane to Shirdi taxi fare", "Thane to Shirdi cab fare"],
["Thane to Shirdi one way cab", "Thane to Shirdi one way taxi"],
["Thane to Shirdi round trip cab", "Thane to Shirdi Ertiga Cab"],
["Thane to Shirdi Innova Cab", "Thane to Shirdi Innova Crysta Cab"],
["Thane to Shirdi Sedan Cab", "Thane to Shirdi car rental"],
["Thane to Shirdi outstation cab", "Thane to Shirdi Sai Baba Darshan Cab"],
["Shirdi to Thane Taxi", "Shirdi to Thane Cab"],
["Sai Shirdi Cabs", "Thane to Shirdi Cab"]
]
,







whychoose: [  
 
    {   
 
        WhyChooseheading: "Thane to Shirdi Cab for Comfortable Outstation Travel",   
 
        WhyChoosedescription: "Sai Shirdi Cabs provides Thane to Shirdi Cab services for devotees, families, tourists, senior citizens, and groups travelling to Shirdi. A private cab can be arranged for a comfortable journey from Thane to Shirdi with suitable pickup locations, planned travel schedules, one-way trips, round trips, Sai Baba Darshan, and nearby sightseeing requirements."   
 
    },   
 
    {   
 
        WhyChooseheading: "Reliable Cab Booking from Thane to Shirdi",   
 
        WhyChoosedescription: "Travellers can book a private cab from different areas of Thane for their journey to Shirdi. Sai Shirdi Cabs can coordinate pickup according to your location and travel requirements, providing a convenient option for passengers who want direct transportation without managing multiple public transport connections during their pilgrimage journey."   
 
    },   
 
    {   
 
        WhyChooseheading: "Private Taxi for Thane to Shirdi Journey",   
 
        WhyChoosedescription: "A private taxi provides a convenient travel option for passengers going from Thane to Shirdi with family members or friends. The journey can be planned according to your preferred departure time, pickup location, passenger count, luggage requirements, and destination, allowing the group to travel together throughout the trip."   
 
    },   
 
    {   
 
        WhyChooseheading: "Thane to Shirdi Cab for Sai Baba Darshan",   
 
        WhyChoosedescription: "Devotees travelling from Thane to Shirdi can book a cab for Sai Baba Darshan and other pilgrimage requirements. After reaching Shirdi, transportation can also be planned for hotel transfers, temple visits, nearby religious places, and other destinations included in the group's travel itinerary."   
 
    },   
 
    {   
 
        WhyChooseheading: "One Way Cab from Thane to Shirdi",   
 
        WhyChoosedescription: "Passengers who only require transportation from Thane to Shirdi can arrange a one-way cab according to their journey requirements. The service can be planned with the preferred pickup point, travel date, passenger count, luggage details, and Shirdi destination for a straightforward intercity transfer."   
 
    },   
 
    {   
 
        WhyChooseheading: "Round Trip Cab from Thane to Shirdi",   
 
        WhyChoosedescription: "Travellers planning to return to Thane after their Shirdi visit can arrange a round-trip cab for the complete journey. This option can be suitable for devotees, families, and tourist groups who want to include Sai Baba Darshan, local sightseeing, nearby pilgrimage destinations, and return travel within their planned itinerary."   
 
    },   
 
    {   
 
        WhyChooseheading: "Thane to Shirdi Cab for Family and Group Travel",   
 
        WhyChoosedescription: "Families and small groups can book a private cab from Thane to Shirdi for pilgrimage and leisure travel. Depending on the group size and travel requirements, suitable transportation can be discussed for carrying passengers and luggage while keeping the journey organized from the Thane pickup point to the Shirdi destination."   
 
    },   
 
    {   
 
        WhyChooseheading: "Book Thane to Shirdi Cab with Sai Shirdi Cabs",   
 
        WhyChoosedescription: "To book a Thane to Shirdi Cab, provide Sai Shirdi Cabs with your pickup location in Thane, travel date, preferred departure time, passenger count, luggage requirements, one-way or round-trip preference, and any sightseeing or pilgrimage plans. Complete journey details help in arranging cab transportation according to your travel needs."   
 
    }   
 
]   
 
 
}; 
 
const faqData = [ 
 
{ 
 
question: "Can I book a Thane to Shirdi Cab?", 
 
answer: "Yes, Sai Shirdi Cabs provides private cab services from Thane to Shirdi for devotees, families, tourists, and groups travelling for pilgrimage, sightseeing, and other purposes." 
 
}, 
 
{ 
 
question: "Can I book a cab from Thane to Shirdi for Sai Baba Darshan?", 
 
answer: "Yes, you can book a private cab from Thane to Shirdi for Sai Baba Darshan and transportation to your hotel, temple area, and other planned pilgrimage destinations." 
 
}, 
 
{ 
 
question: "Is one-way cab service available from Thane to Shirdi?", 
 
answer: "Yes, one-way cab bookings can be arranged from Thane to Shirdi according to your pickup location, travel date, passenger count, luggage requirements, and destination." 
 
}, 
 
{ 
 
question: "Can I book a round-trip cab from Thane to Shirdi?", 
 
answer: "Yes, round-trip cab services can be arranged for passengers travelling from Thane to Shirdi who also require return transportation after their pilgrimage or sightseeing trip." 
 
}, 
 
{ 
 
question: "Can families book a Thane to Shirdi taxi?", 
 
answer: "Yes, families can book a private taxi from Thane to Shirdi for Sai Baba Darshan, family trips, sightseeing, and other travel requirements according to their group size and itinerary." 
 
}, 
 
{ 
 
question: "Can I book a Thane to Shirdi cab for a group?", 
 
answer: "Yes, small groups can arrange private cab transportation from Thane to Shirdi based on the number of passengers, luggage requirements, travel schedule, and preferred vehicle arrangement." 
 
}, 
 
{ 
 
question: "Can I include sightseeing in my Thane to Shirdi trip?", 
 
answer: "Yes, sightseeing requirements can be discussed when booking your Thane to Shirdi cab, allowing the travel plan to include selected attractions and pilgrimage destinations according to your itinerary." 
 
}, 
 
{ 
 
question: "Can I book a cab from any area of Thane?", 
 
answer: "Yes, cab pickup can be planned from your preferred location in Thane based on availability and the travel details provided during the booking process." 
 
}, 
 
{ 
 
question: "Can I travel from Thane to Shirdi with luggage?", 
 
answer: "Yes, passengers can travel with luggage, and you should provide your luggage details and passenger count while booking so the transportation arrangement can be planned according to your requirements." 
 
}, 
 
{ 
 
question: "How can I book a Thane to Shirdi Cab?", 
 
answer: "You can contact Sai Shirdi Cabs with your Thane pickup location, travel date, departure time, passenger count, luggage details, one-way or round-trip requirement, and sightseeing plans to arrange your cab booking." 
 
} 
 
]; 
 
const testimonials = [ 
 
{ 
 
id: 1, 
 
name: "Mr. Sagar Patil", 
 
feedback: "We booked a Thane to Shirdi Cab for our family pilgrimage. The private cab made the journey convenient because we could travel together with our luggage and continue with our Sai Baba Darshan plans after reaching Shirdi.", 
 
rating: 5 
 
}, 
 
{ 
 
id: 2, 
 
name: "Mrs. Kavita Deshmukh", 
 
feedback: "Our family travelled from Thane to Shirdi by cab for Sai Baba Darshan. The private transportation was convenient for our group, and we were able to manage our journey according to our planned travel schedule.", 
 
rating: 5 
 
} 
 
];






    const Images = [
        { place: "/images/keyword/1.jpg", text: "Nagarsol to Shirdi Cab", link: "Nagarsol-to-Shirdi-Cab" },
        { place: "/images/keyword/2.jpg", text: "Shirdi Cab Service", link: "Shirdi-Cab-Service" },
        { place: "/images/keyword/3.jpg", text: "Shirdi to Shani Shingnapur Cab", link: "Shirdi-to-Shani-Shingnapur-Cab" },
        { place: "/images/keyword/4.jpg", text: "Shirdi to Grishneshwar Cab", link: "Shirdi-to-Grishneshwar-Cab" },
        { place: "/images/keyword/5.jpg", text: "Shirdi to Manmad Cab", link: "Shirdi-to-Manmad-Cab" },
        { place: "/images/keyword/6.jpg", text: "Shirdi to Lonavala Cab", link: "Shirdi-to-Lonavala-Cab" },
        { place: "/images/keyword/7.jpg", text: "Shirdi to Mahabaleshwar Cab", link: "Shirdi-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/8.jpg", text: "Shirdi to Ashtavinayak Darshan Package", link: "Shirdi-to-Ashtavinayak-Darshan-Package" },
        { place: "/images/keyword/9.jpg", text: "Shirdi to Saptashrungi Cab", link: "Shirdi-to-Saptashrungi-Cab" },
        { place: "/images/keyword/10.jpg", text: "Shirdi Tour Package", link: "Shirdi-Tour-Package" },
        { place: "/images/keyword/11.jpg", text: "Best Taxi Service in Shirdi", link: "Best-Taxi-Service-in-Shirdi" },
        { place: "/images/keyword/12.jpg", text: "Shirdi Airport Cab Service", link: "Shirdi-Airport-Cab-Service" },
        { place: "/images/keyword/13.jpg", text: "Online Cab Booking Shirdi", link: "Online-Cab-Booking-Shirdi" },
        { place: "/images/keyword/14.jpg", text: "Best Travel Agency in Shirdi", link: "Best-Travel-Agency-in-Shirdi" },
        { place: "/images/keyword/15.jpg", text: "Shirdi to Mumbai Airport Cab", link: "Shirdi-to-Mumbai-Airport-Cab" },
        { place: "/images/keyword/16.jpg", text: "Kopargaon to Shirdi Cab", link: "Kopargaon-to-Shirdi-Cab" },
        { place: "/images/keyword/17.jpg", text: "Innova on Rent in Shirdi", link: "Innova-on-Rent-in-Shirdi" },
        { place: "/images/keyword/18.jpg", text: "Shirdi Sightseeing Cab", link: "Shirdi-Sightseeing-Cab" },
        { place: "/images/keyword/19.jpg", text: "Shirdi Darshan Taxi", link: "Shirdi-Darshan-Taxi" },
        { place: "/images/keyword/20.jpg", text: "Bus on Hire in Shirdi", link: "Bus-on-Hire-in-Shirdi" },
        { place: "/images/keyword/21.jpg", text: "Best Sedan Cab in Shirdi", link: "Best-Sedan-Cab-in-Shirdi" },
        { place: "/images/keyword/22.jpg", text: "Ertiga Car Hire in Shirdi", link: "Ertiga-Car-Hire-in-Shirdi" },
        { place: "/images/keyword/23.jpg", text: "Innova Crysta on Rent in Shirdi", link: "Innova-Crysta-on-Rent-in-Shirdi" },
        { place: "/images/keyword/24.jpg", text: "Mini Bus on Rent in Shirdi", link: "Mini-Bus-on-Rent-in-Shirdi" },
        { place: "/images/keyword/25.jpg", text: "Tempo Traveller Hire in Shirdi", link: "Tempo-Traveller-Hire-in-Shirdi" },
    ];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Thane to Shirdi Cab",
  "image": "https://www.saishirdicabs.com/assets/images/thane-to-shirdi-cab.webp",
  "description":
    "Book a Thane to Shirdi Cab with Sai Shirdi Cabs for a comfortable, convenient, and reliable journey from Thane to Shirdi. Our cab service is suitable for Sai Baba Darshan, family trips, pilgrimage travel, one-way journeys, round trips, and outstation travel. Get well-maintained cars, professional drivers, affordable fares, flexible pickup and drop locations, and easy booking assistance.",
  "brand": {
    "@type": "Brand",
    "name": "Sai Shirdi Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.saishirdicabs.com/thane-to-shirdi-cab"
  }
};





    return (
        <div>


<Helmet>
  <title>Thane to Shirdi Cab | Thane to Shirdi Taxi | +91 7776814559</title>

  <meta
    name="description"
    content="Book a Thane to Shirdi Cab with Sai Shirdi Cabs for a comfortable and reliable journey. Get professional drivers, well-maintained cars, affordable fares and easy booking for Sai Baba Darshan, one-way and round trips."
  />

  <meta
    name="keywords"
    content="Thane to Shirdi Cab, Thane to Shirdi Taxi, Thane to Shirdi cab service, Thane to Shirdi taxi service, Thane to Shirdi cab booking, Thane to Shirdi taxi booking, Thane to Shirdi taxi fare, Thane to Shirdi cab fare, Thane to Shirdi one way cab, Thane to Shirdi one way taxi, Thane to Shirdi round trip cab, Thane to Shirdi round trip taxi"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/102.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Sai Shirdi Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Sai Shirdi Cabs</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Shirdi Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917776814559" className="pc-call">+91 7776814559 </a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+919579032227" className="pc-call">+91 9579032227 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91917776814559 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917776814559 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@saishirdicabs.com" className="pc-email">
                                            booking@saishirdicabs.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Sai Shirdi Cabs</strong><br />
                                            Sai Mandir Lene, Near Hotel Sai Kanhaiya,
                                            Shirdi,Tel - Rahata,Dist Ahilyanagar,
                                            Maharashtra, India - 423109




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Thanetoshirdicab;